import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./MobileAppReviewRates.component.css";
import Helpers from "../../common/util/Helpers";
import PetPlanCollapse from "./PetPlanCollapse.component";
import { Form } from "informed";
import { getProtectedSinceDate } from "../../common/util/util";
import SignaturePanel from "./SignaturePanel.component";
import HighDeductiblePanel from "./HighDeductiblePanel.component";

function truncateWithEllipsis(name, maxLength = 20) {
  if (!name) return "";
  return name.length > maxLength 
    ? name.substring(0, maxLength).replace(/\s+$/, "") + "…" 
    : name;
}

class MobileAppReviewRates extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedPlan: props.selectedPlan ? props.selectedPlan : this.getDefaultPlan(),
            selectedPlanType: "signature",
            selectedCoinsurance: null,
            selectedDeductible: null,
            selectedCoverage: null,
            selectedPremium: null,
            selectedHighDeductibleCoinsurance: null,
            selectedHighDeductibleDeductible: null,
            selectedHighDeductibleCoverage: null,
            selectedHighDeductiblePremium: null,
            tempSelectedCoinsurance: null,
            tempSelectedDeductible: null,
            tempSelectedPolicyLimit: null,
            tempSelectedCoverage: null,
            tempSelectedPremium: null,
            tempSelectedHighDeductibleCoinsurance: null,
            tempSelectedHighDeductibleDeductible: null,
            tempSelectedHighDeductibleCoverage: null,
            tempSelectedHighDeductiblePremium: null,
        }
        this.totalMonthlyRate_existingPets = 0;
        this.props.existingPets.map(pet => (this.totalMonthlyRate_existingPets += Number(pet.MonthlyPremium.replace("$","").replace(",",""))));
        this.hasSignaturePLanOptions = false;
        this.hasHighDeductiblePlanOptions = false;
    }

    componentDidMount() {
        this.props.setNewRoute("/MobileAppAddPet/Step2");

        //For google analytics
        window.dataLayer.push({
            'event': 'Pageview',
            'url': window.location.pathname + '/Step2'
        });


        // iterate through the policy details and set the default selectedCoinsurance, selectedDeductible, selectedCoverage, 
        // selectedHighDeductibleCoinsurance, selectedHighDeductibleDeductible, selectedHighDeductibleCoverage
        // based on the available policies
        // if 80% and $3000 is available, set it as the default high deductible plan
        // if 80% and $500 is available, set it as the default signature plan
        let lowestReimbursement = 100;
        let highestDeductible = 0;
        let highestPolicyLimit = 0;
        let lowestPremium = 1000000;
        let lowestHighDeductibleReimbursement = 100;
        let highestHighDeductibleDeductible = 0;
        let lowestHighDeductiblePremium = 1000000;
        let defaultHighDeductibleReimbursement = 80;
        let defaultHighDeductibleDeductible = 1500;
        let defaultHighDeductiblePremium = 50;
        let defaultSignatureReimbursement = 80;
        let defaultSignatureDeductible = 500;
        let defaultSignaturePremium = 50;
        let defaultPolicyLimit = 0;
        let hasDefaultHighDeductibleCoverage = false;
        let hasDefaultSignatureCoverage = false;
        let selectedPlanType = "signature";
        for (let i = 0; i < this.props.policyDetails.policies.length; i++) {

            if (this.props.policyDetails.policies[i].reimbursement*100 == defaultHighDeductibleReimbursement && this.props.policyDetails.policies[i].deductible == defaultHighDeductibleDeductible) {
                hasDefaultHighDeductibleCoverage = true;    
                defaultHighDeductiblePremium = this.props.policyDetails.policies[i].monthly_premium;
            }
            if (this.props.policyDetails.policies[i].reimbursement*100 == defaultSignatureReimbursement && this.props.policyDetails.policies[i].deductible == defaultSignatureDeductible) {
                hasDefaultSignatureCoverage = true;
                defaultSignaturePremium = this.props.policyDetails.policies[i].monthly_premium;
            }

            if (this.props.policyDetails.policies[i].deductible >= 1500) {
                this.hasHighDeductiblePlanOptions = true;
                if (!hasDefaultHighDeductibleCoverage) {
                    if (this.props.policyDetails.policies[i].reimbursement*100 < lowestHighDeductibleReimbursement) {
                        lowestHighDeductibleReimbursement = this.props.policyDetails.policies[i].reimbursement*100;
                        lowestHighDeductiblePremium = this.props.policyDetails.policies[i].monthly_premium;
                    }
                    // hard code to 1500 deductible
                    highestHighDeductibleDeductible = 1500;
                    // if (this.props.policyDetails.policies[i].deductible > highestHighDeductibleDeductible) {
                    //     highestHighDeductibleDeductible = this.props.policyDetails.policies[i].deductible;
                    //     lowestHighDeductiblePremium = this.props.policyDetails.policies[i].monthly_premium;
                    // }
                }
            } else {
                this.hasSignaturePlanOptions = true;
                if (!hasDefaultSignatureCoverage) {
                    if (this.props.policyDetails.policies[i].reimbursement*100 < lowestHighDeductibleReimbursement) {
                        lowestReimbursement = this.props.policyDetails.policies[i].reimbursement*100;
                        lowestPremium = this.props.policyDetails.policies[i].monthly_premium;
                    }
                    if (this.props.policyDetails.policies[i].deductible > highestHighDeductibleDeductible) {
                        highestDeductible = this.props.policyDetails.policies[i].deductible;
                        lowestPremium = this.props.policyDetails.policies[i].monthly_premium;
                    }
                }
            }
        }   

        let annualLimitOptions = [];
        this.props.policyDetails.policies.map(policy => {
            if (!annualLimitOptions.find(ele => ele.value === policy.annual_limit)) {
                    let obj = { displayName: "$" + policy.annual_limit, value: policy.annual_limit }
                    annualLimitOptions.push(obj);
            }
        });

        annualLimitOptions.sort((op1, op2) => {
            if (op1.value > op2.value) return 1;
            return -1;
        })

        defaultPolicyLimit = annualLimitOptions.length > 0 ? annualLimitOptions[0].value : null;
        highestPolicyLimit = defaultPolicyLimit;

        if (hasDefaultHighDeductibleCoverage) {
            lowestHighDeductibleReimbursement = defaultHighDeductibleReimbursement;
            highestHighDeductibleDeductible = defaultHighDeductibleDeductible;
            lowestHighDeductiblePremium = defaultHighDeductiblePremium;
        } 
        if (hasDefaultSignatureCoverage) {
            lowestReimbursement = defaultSignatureReimbursement;
            highestDeductible = defaultSignatureDeductible;
            lowestPremium = defaultSignaturePremium;
        }

        if (!this.state.selectedPlan) {
            let selectedPlan = this.props.policyDetails.policies.find(policy => policy.reimbursement*100 == lowestReimbursement && policy.deductible == highestDeductible);
            this.props.setSelectedPlan(selectedPlan, (this.totalMonthlyRate_existingPets + selectedPlan.monthly_total_payment).toFixed(2));
        } else {

            // set the defaults to the selected plan
            if (this.state.selectedPlan.deductible >= 1500) {
                lowestHighDeductibleReimbursement = this.state.selectedPlan.reimbursement*100;
                highestHighDeductibleDeductible = this.state.selectedPlan.deductible;
                lowestHighDeductiblePremium = this.state.selectedPlan.monthly_premium;
                selectedPlanType = "highdeductible";
            } else {
                lowestReimbursement = this.state.selectedPlan.reimbursement*100;
                highestDeductible = this.state.selectedPlan.deductible;
                lowestPremium = this.state.selectedPlan.monthly_premium;
                selectedPlanType = "signature";
            }

            this.props.setSelectedPlan(this.state.selectedPlan, (this.totalMonthlyRate_existingPets + this.state.selectedPlan.monthly_total_payment).toFixed(2));
        }
        
        this.setState({
            selectedPlanType: selectedPlanType,
            selectedCoinsurance: lowestReimbursement,
            selectedDeductible: highestDeductible,
            selectedCoverage: lowestReimbursement + "_" + highestDeductible,
            selectedPremium: lowestPremium,
            selectedHighDeductibleCoinsurance: lowestHighDeductibleReimbursement,
            selectedHighDeductibleDeductible: highestHighDeductibleDeductible,
            selectedHighDeductibleCoverage: lowestHighDeductibleReimbursement + "_" + highestHighDeductibleDeductible,
            selectedHighDeductiblePremium: lowestHighDeductiblePremium,
            tempSelectedCoinsurance: lowestReimbursement,
            tempSelectedDeductible: highestDeductible,
            tempSelectedPolicyLimit: highestPolicyLimit,
            tempSelectedCoverage: lowestReimbursement + "_" + highestDeductible,
            tempSelectedPremium: lowestPremium,
            tempSelectedHighDeductibleCoinsurance: lowestHighDeductibleReimbursement,
            tempSelectedHighDeductibleDeductible: highestHighDeductibleDeductible,
            tempSelectedHighDeductibleCoverage: lowestHighDeductibleReimbursement + "_" + highestHighDeductibleDeductible,
            tempSelectedHighDeductiblePremium: lowestHighDeductiblePremium
        });        
    }

    //handleCoinsuranceChange = (option) => {
    //    const selectedPlan = this.props.policyDetails.policies.find(plan => (plan.reimbursement*100 == option.currentTarget.value && plan.deductible == this.state.tempSelectedDeductible));

    //    this.setState({
    //        tempSelectedCoinsurance: option.currentTarget.value,
    //        tempSelectedPremium: selectedPlan.monthly_premium
    //    })

    //}

    handleCoinsuranceChange = (option) => {
        const selectedCoinsurance = Number(option.currentTarget.value);
        const { tempSelectedDeductible, tempSelectedPolicyLimit } = this.state;

        const selectedPlan = this.props.policyDetails.policies.find(plan =>
            plan.reimbursement * 100 === selectedCoinsurance &&
            plan.deductible === tempSelectedDeductible &&
            String(plan.annual_limit) === String(tempSelectedPolicyLimit)
        );

        this.setState({
            tempSelectedCoinsurance: selectedCoinsurance,
            tempSelectedPremium: selectedPlan
                ? selectedPlan.monthly_premium
                : this.state.tempSelectedPremium // KEEP OLD VALUE
        });
    };
    
    //handleDeductibleChange = (option) => {
    //    const selectedPlan = this.props.policyDetails.policies.find(plan => (plan.reimbursement*100 == this.state.tempSelectedCoinsurance && plan.deductible == option.currentTarget.value));

    //    this.setState({
    //        tempSelectedDeductible: option.currentTarget.value,
    //        tempSelectedPremium: selectedPlan.monthly_premium
    //    })
    //}  
    handleDeductibleChange = (option) => {
        const selectedDeductible = Number(option.currentTarget.value);
        const { tempSelectedCoinsurance, tempSelectedPolicyLimit } = this.state;

        const selectedPlan = this.props.policyDetails.policies.find(plan =>
            plan.reimbursement * 100 === tempSelectedCoinsurance &&
            plan.deductible === selectedDeductible &&
            String(plan.annual_limit) === String(tempSelectedPolicyLimit)
        );

        this.setState({
            tempSelectedDeductible: selectedDeductible,
            tempSelectedPremium: selectedPlan
                ? selectedPlan.monthly_premium
                : this.state.tempSelectedPremium //KEEP OLD VALUE
        });
    };

    handlePolicyLimitChange = (option) => {
        const selectedPolicyLimit = option.currentTarget.value;
        const { tempSelectedCoinsurance, tempSelectedDeductible } = this.state;

        const selectedPlan = this.props.policyDetails.policies.find(plan =>
            plan.reimbursement * 100 === tempSelectedCoinsurance &&
            plan.deductible === tempSelectedDeductible &&
            String(plan.annual_limit) === String(selectedPolicyLimit)
        );

        this.setState({
            tempSelectedPolicyLimit: selectedPolicyLimit,
            tempSelectedPremium: selectedPlan
                ? selectedPlan.monthly_premium
                : this.state.tempSelectedPremium // PREVENT RESET
        });
    }; 

    handleHighDeductibleCoinsuranceChange = (option) => {
        const selectedPlan = this.props.policyDetails.policies.find(plan => (plan.reimbursement*100 == option.currentTarget.value && plan.deductible == this.state.tempSelectedHighDeductibleDeductible));

        this.setState({
            tempSelectedHighDeductibleCoinsurance: option.currentTarget.value,
            tempSelectedHighDeductiblePremium: selectedPlan.monthly_premium
        })
    }
    handleHighDeductibleDeductibleChange = (option) => {
        const selectedPlan = this.props.policyDetails.policies.find(plan => (plan.reimbursement*100 == this.state.tempSelectedHighDeductibleCoinsurance && plan.deductible == option.currentTarget.value));

        this.setState({
            tempSelectedHighDeductibleDeductible: option.currentTarget.value,
            tempSelectedHighDeductiblePremium: selectedPlan.monthly_premium
        })
    }
    

    setSelectedPlanType = (planType) => {
        let selectedPlan = null;

        // Set the selected plan to the plan that matches the coinsurance and deductible
        selectedPlan = this.props.policyDetails.policies.find(policy => policy.reimbursement * 100 == this.state.tempSelectedCoinsurance && policy.deductible == this.state.tempSelectedDeductible && policy.annual_limit === this.state.tempSelectedPolicyLimit);

        this.setState({
            selectedPlanType: planType,
            selectedPlan: selectedPlan,
            selectedCoinsurance: this.state.tempSelectedCoinsurance,
            selectedDeductible: this.state.tempSelectedDeductible,
            selectedCoverage: this.state.tempSelectedCoinsurance + "_" + this.state.tempSelectedDeductible,
            selectedPremium: this.state.tempSelectedPremium
        })
        this.props.setSelectedPlan(selectedPlan, (this.totalMonthlyRate_existingPets + selectedPlan.monthly_total_payment).toFixed(2));

    }

    getDefaultPlan = () => {
        let plan = this.props.policyDetails.policies.find(policy => policy.default_plan);
        if (!plan && this.props.policyDetails.policies.length > 0) {
            plan = this.props.policyDetails.policies[0];
        }
        return plan;
    }

    petPlanList = () => (
        this.props.existingPets.map((pet) => {
            return (
                <PetPlanCollapse key={pet.PetID} plan={pet} />
            );
        })
    );

    nextStep = () => {
        this.props.stepper.nextStep();
    }

    stateVerification = (state) => {
        if (state === "NH" || state === "MD")
            return true;
        return false;
    }

    goToPreviousStep = () => {
        this.props.setSelectedPlan(null, 0);
        this.props.stepper.previousStep();
    }

    render() {
        const { selectedPlan } = this.state;
        const breed = this.props.breedsData.find(breed => breed.id === Number(this.props.petDetails.breed));
        const billingState = this.props.physicalAddress.State;

        return (
            <Form
                onSubmit={this.nextStep}
            >
                <div className="container review-rates">
                    <h1 className="text-primary mb-3 mb-lg-0 text-truncate">Review your plan options</h1>
                    <div className="row">
                        <div className="col-lg-8 d-flex flex-column flex-fill">
                            <div className="row">
                                <div className="col-md-6 mb-2" style={{ paddingRight: "10px", paddingLeft: "10px" }}>
                                    <div className="pet-details-edit">
                                        <div className="pet-details-info">
                                            <h2 className="pet-details-name">
                                                {/*
                                                    this.props.petDetails.petType === "dog" ?
                                                        <img className="d-none mr-2 d-md-inline pet-icon" alt="dog" src="../../assets/images/add-dog.svg"></img> :
                                                        <img className="d-none mr-2 d-md-inline pet-icon" alt="cat" src="../../assets/images/add-cat.svg"></img>
                                                */}
                                                {truncateWithEllipsis(this.props.petDetails.petName, 20)}
                                            </h2>
                                            <div className="mt-2">
                                                <span className="pet-details-age-breed pet-details-truncate">{this.props.petAge == 0 ? (this.props.petDetails.petType === "dog" ? "Under 1 Year" : "Under 1 Year") : "Age " + this.props.petAge}, {breed.name}</span>
                                                <span className="edit-link-text ml-3" onClick={() => this.goToPreviousStep()} ><img src="/assets/images/Edit.png" alt="Edit" className="edit-pet-icon" />Edit Pet</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="plan-selector-container">
                                
                            <div className="row d-flex gx-4">
                                    {this.hasSignaturePlanOptions && (
                                    <div className="d-inline col-md-12">
                                        <div className="px-2 align-top">

                                            <SignaturePanel
                                                policyDetails={this.props.policyDetails}
                                                selectedPlan={this.state.selectedPlan}
                                                selectedPlanType={this.state.selectedPlanType}
                                                setSelectedPlanType={this.setSelectedPlanType}
                                                handleCoinsuranceChange={this.handleCoinsuranceChange}
                                                handleDeductibleChange={this.handleDeductibleChange}
                                                handlePolicyLimitChange={this.handlePolicyLimitChange}
                                                selectedCoinsurance={this.state.selectedCoinsurance}
                                                selectedDeductible={this.state.selectedDeductible}
                                                selectedCoverage={this.state.selectedCoverage}
                                                selectedPremium={this.state.selectedPremium}
                                                tempSelectedCoinsurance={this.state.tempSelectedCoinsurance}
                                                tempSelectedDeductible={this.state.tempSelectedDeductible}
                                                tempSelectedCoverage={this.state.tempSelectedCoverage}
                                                tempSelectedPremium={this.state.tempSelectedPremium}
                                                tempSelectedPolicyLimit={this.state.tempSelectedPolicyLimit}
                                            />

                                        </div>
                                    </div>
                                    )}
                                    {/*{this.hasHighDeductiblePlanOptions && (*/}
                                    {/*<div className="d-inline col-md-6">*/}
                                    {/*    <div className="px-2 align-top">*/}

                                    {/*        <HighDeductiblePanel */}
                                    {/*            policyDetails={this.props.policyDetails}*/}
                                    {/*            selectedPlan={this.state.selectedPlan}*/}
                                    {/*            selectedPlanType={this.state.selectedPlanType}*/}
                                    {/*            setSelectedPlanType={this.setSelectedPlanType}*/}
                                    {/*            handleCoinsuranceChange={this.handleHighDeductibleCoinsuranceChange}*/}
                                    {/*            handleDeductibleChange={this.handleHighDeductibleDeductibleChange}*/}
                                    {/*            selectedCoinsurance={this.state.selectedHighDeductibleCoinsurance}*/}
                                    {/*            selectedDeductible={this.state.selectedHighDeductibleDeductible}*/}
                                    {/*            selectedCoverage={this.state.selectedHighDeductibleCoverage}*/}
                                    {/*            selectedPremium={this.state.selectedHighDeductiblePremium}*/}
                                    {/*            tempSelectedCoinsurance={this.state.tempSelectedHighDeductibleCoinsurance}*/}
                                    {/*            tempSelectedDeductible={this.state.tempSelectedHighDeductibleDeductible}*/}
                                    {/*            tempSelectedCoverage={this.state.tempSelectedHighDeductibleCoverage}*/}
                                    {/*            tempSelectedPremium={this.state.tempSelectedHighDeductiblePremium}*/}
                                    {/*        />*/}

                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    {/*)}*/}
                                </div>
                            </div>

                            <div className="mt-4">
                                <h3>Your Currently Enrolled Pets</h3>
                            </div>

                            <div className="pet-list-container">
                                <div className="row d-flex gx-4">
                                    {this.petPlanList()}
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4">
                            <div className="new-rate-container">
                            <p className={
this
.props.policyDetails.isDiscountApplied ?
"d-none d-sm-block discountsApplied"
:
"d-none discountsApplied"
} ><img src=
"../../assets/images/discountLogo.png"
/>
All
available discounts applied!</p>
                                <div className="d-none d-sm-block rate-container text-center">
                                    <h2 className="font-weight-bold d-none d-md-block">New Total Monthly Premium For Your Pets</h2>
                                    <h4 className="d-md-none"> Total Monthly Premium For Your Pets</h4>
                                    <div className="rate-text-large">{Helpers.formatCurrency(this.totalMonthlyRate_existingPets + selectedPlan.monthly_total_payment)}<small>/month</small></div>
                                    <div className="button-container mt-3 d-none d-md-flex flex-column">
                                        <button
                                            className="button-primary next-btn"
                                            type="button"
                                            onClick={this.nextStep}
                                        >Next 
                                        </button>
                                        <Link to="/" >
                                            <button
                                                className="button-link"
                                                type="button"
                                            >Cancel
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="effective-details d-md-none">
                                    <p className="effective-date"><span className="truncate" style={{ textTransform: "capitalize" }} >{this.props.petDetails.petName}</span>'s policy effective date is {this.props.policyDetails.policy_effective_date}</p>
                                    <ul>
                                        {/* Logic for Non Model Law states - 2024*/}
                                        {!this.props.userAccountDetails.ModelLawInEffect && <li>A 15 day waiting period applies for accidents and illnesses.</li>}
                                        {!this.props.userAccountDetails.ModelLawInEffect && this.props.petAge < 6 && <li>A 12 month waiting period applies for illnesses related to hip dysplasia.</li>}
                                        {/* Logic for Model Law states - 2024*/}
                                        {this.props.userAccountDetails.ModelLawInEffect && <li>There is a 15-day waiting period from the pet policy effective date for illness{this.props.physicalAddress.State === "WA" ? "" : ", injury"} and orthopedic conditions (other than hip dysplasia) not resulting from an accident for {this.props.petDetails.petName}.</li>}
                                        {this.props.userAccountDetails.ModelLawInEffect && this.props.petAge < 6 && <li>A 30-day waiting period applies to hip dysplasia not resulting from an accident.</li>}
                                        {this.props.userAccountDetails.ModelLawInEffect && <li>However, waiting periods will not apply if waived by us upon completion of a complete clinical examination</li>}
                                    </ul>
                                </div>
                                <div className="effective-details d-none d-md-flex">
                                    <i className="fa fa-calendar calendar-icon"></i>
                                    <div className="">
                                        <p className="effective-date"><span className="truncate" style={{ textTransform: "capitalize" }} >{this.props.petDetails.petName}</span>'s policy effective date is {this.props.policyDetails.policy_effective_date}</p>
                                        {this.props.physicalAddress.State!=="MD"&&
                                        <ul>
                                            {/* Non Model Law Logic */}
                                            {!this.props.userAccountDetails.ModelLawInEffect && <li>There is a 15-day waiting period for all accidents and illnesses. The waiting period starts on your policy effective date, {getProtectedSinceDate(this.props.policyDetails.policy_effective_date)}</li>}
                                            {!this.props.userAccountDetails.ModelLawInEffect && this.props.petAge < 6 && <li>There is a 12-month waiting period for hip dysplasia for pets younger than six years old.</li>}

                                            {/* ModelLaw Logic */}
                                            {this.props.userAccountDetails.ModelLawInEffect && <li>There is a 15-day waiting period from the pet policy effective date for illness, {this.props.physicalAddress.State==="WA"? "":"injury"} and orthopedic conditions (other than hip dysplasia) not resulting from an accident. However, this waiting period will be waived by us upon completion of a complete clinical examination. The waiting period starts on your policy effective date, {this.props.policyDetails.policy_effective_date}</li>}
                                            {this.props.userAccountDetails.ModelLawInEffect && this.props.petAge < 6 && <li>There is a 30-day waiting period from the pet policy effective date, {this.props.policyDetails.policy_effective_date}, for hip dysplasia not resulting from an accident. However, this waiting period will be waived by us upon completion of a complete clinical examination.</li>}
                                            
                                        </ul>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-none sticky-bottom">
                        <div className="col-md-8 p-0">
                        <p className={
this
.props.policyDetails.isDiscountApplied ?
"d-block d-md-none discountsApplied"
:
"d-none discountsApplied"
} ><img src=
"../../assets/images/discountLogo.png"
/>
All
available discounts applied!</p>
                       
                            <div className="d-md-none text-center sticky-bottom-title">Total Monthly Premium For Your Pets</div>
                            <div className="d-md-none text-center"><span className="font-weight-bold sticky-bottom-rate-text">{Helpers.formatCurrency(this.totalMonthlyRate_existingPets + selectedPlan.monthly_total_payment)}</span><small>/month</small></div>

                            <button
                                className="button-primary-plusV2"
                                type="submit" style={{ backgroundColor: "#008762", borderColor: "#008762"}}
                            > 

                                <div class="">
                                     <div class="">
                                        Confirm Rate
                                        <img className="next-arrow-circle-right-custom" alt="next" src="/assets/images/next-arrow.svg"></img>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

export default MobileAppReviewRates;